import React from 'react'
import { l } from '@manychat/manyui'

export const InstagramReloadPermissionsSomethingWentWrong = () => {
  return (
    <span>
      {l.translate('Something went wrong while refreshing Instagram channel permissions')}
    </span>
  )
}
